import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import getQueryParams from '@/utils/getQueryParams';
import store from '@/store/BookingStore';
import { createRequestData } from '@/logic/createRequestParams';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { Booking, StatusV2 } from '../../../../../requests-module/src';
import checkIsPackageTrain from '@/logic/options/checkIsPackageTrain';
import {
    saveUrlTokenMapping,
    tryRestoreTokenFromUrlCache,
} from '@/logic/bookingFunnel/bookingFunnelUrlTokenCache';

export const trainStep = new FunnelStep({
    name: RouteNameEnum.Train,
    dependencies: [],
    init: async () => {
        const queryParams = getQueryParams()

        let response: Booking | { error: string } | null = null
        if (!store.getters.getToken) {
            const restored = tryRestoreTokenFromUrlCache()
            if (restored) {
                console.log('init(): Train Page - restored BO from URL cache, refresh instead of init');
                response = await BookingFunnelService.refreshBookingTrain()
                if ('error' in response) {
                    throw new Error('Error with api')
                }
                saveUrlTokenMapping(window.location.href, response.boReference)

                if (response.status == StatusV2.PROCESSING) {
                    return '/payment'
                }
                if (response.status == StatusV2.SUCCESS) {
                    return '/paid'
                }
                if (!checkIsPackageTrain(response)) {
                    return '/options'
                }
                return false
            }

            console.log('init(): Initializing Train Page - make an init call to get BO with defaults');
            // no bo - create one from url 
            const requestData = createRequestData(queryParams);

            response = await BookingFunnelService.initBookingTrain(requestData)
            if ('error' in response) {
                throw new Error('Error with api')
            }

            store.commit('setToken', response.boReference)
            saveUrlTokenMapping(window.location.href, response.boReference)

        } else {
            console.log('init(): Initializing Train Page - if bo exist, just make a refresh call');
            // has bo, make a refresh call with alt options
            response = await BookingFunnelService.refreshBookingTrain()
            if ('error' in response) {
                throw new Error('Error with api')
            }
            saveUrlTokenMapping(window.location.href, response.boReference)

            if (response.status == StatusV2.PROCESSING) {
                // proccesing payment go to /payment page
                return '/payment'
            }

            if (response.status == StatusV2.SUCCESS) {
                return '/paid'
            }

            if (!checkIsPackageTrain(response)) {
                return '/options'
            }
            return false
        }
    },

    hasToBeLoggedIn: false
});
